export enum MaritalStatus {
	Unknown = 'Unknown',
	Single = 'Single',
	Married = 'Married',
	Divorced = 'Divorced',
	Widow = 'Widow',
	Cohabitee = 'Cohabitee',
}